'use strict';

// @flow

//
// -------------------- Clients --------------------
//

// Loaders
var DataLoader = require('./build/clients/loaders/DataLoader');
var PagedDataLoader = require('./build/clients/loaders/PagedDataLoader');
var PagedRoomsLoader = require('./build/clients/loaders/PagedRoomsLoader');
var UserRoomsLoader = require('./build/clients/loaders/UserRoomsLoader');
var TeamMembersLoader = require('./build/clients/loaders/TeamMembersLoader');

// Managers TODO
// var CalendarDaysManager = require('./build/clients/managers/CalendarDaysManager');
// var ChatManager = require('./build/clients/managers/ChatManager');
// var EventsManager = require('./build/clients/managers/EventsManager');

//Reducers
var FirebaseCalendarInstances = require('./build/clients/reducers/FirebaseCalendarInstances');
var FirebaseClockOffset = require('./build/clients/reducers/FirebaseClockOffset');
var FirebaseRooms = require('./build/clients/reducers/FirebaseRooms');
var FirebaseUser = require('./build/clients/reducers/FirebaseUser');
var FirebaseUserAuth = require('./build/clients/reducers/FirebaseUserAuth');
var ScheduleCalendarDays = require('./build/clients/reducers/ScheduleCalendarDays');
var ScheduleEvents = require('./build/clients/reducers/ScheduleEvents');

//
// -------------------- Utils --------------------
//
var ChatUtils = require('./build/ChatUtils');
var UserUtils = require('./build/UserUtils');
var TeamUtils = require('./build/TeamUtils');
var LambdaUtils = require('./build/LambdaUtils');
var FirebaseUtils = require('./build/FirebaseUtils');
var TimeUtils = require('./build/TimeUtils');
var AlgoliaUtils = require('./build/AlgoliaUtils');
var ModulesUtils = require('./build/ModulesUtils');
var PhoneNumberUtils = require('./build/PhoneNumberUtils');
var JobsUtils = require('./build/JobsUtils')

module.exports = {
  // Loaders
  DataLoader: DataLoader, PagedDataLoader: PagedDataLoader, PagedRoomsLoader: PagedRoomsLoader,
  UserRoomsLoader: UserRoomsLoader, TeamMembersLoader: TeamMembersLoader,
  // Managers
  // CalendarDaysManager, ChatManager, EventsManager,
  // Reducers
  FirebaseCalendarInstances: FirebaseCalendarInstances, FirebaseClockOffset: FirebaseClockOffset, FirebaseRooms: FirebaseRooms, FirebaseUser: FirebaseUser,
  FirebaseUserAuth: FirebaseUserAuth, ScheduleCalendarDays: ScheduleCalendarDays, ScheduleEvents: ScheduleEvents,
  // Utils
  ChatUtils: ChatUtils, UserUtils: UserUtils, TeamUtils: TeamUtils, LambdaUtils: LambdaUtils, FirebaseUtils: FirebaseUtils, TimeUtils: TimeUtils, JobsUtils: JobsUtils,
  AlgoliaUtils: AlgoliaUtils, ModulesUtils: ModulesUtils, PhoneNumberUtils: PhoneNumberUtils
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fibo-app/fibo-collab-shared/index.js
// module id = 43
// module chunks = 0